import { TAction } from '../actions/types/action';
import { SET_LOCALE_CONFIG_CODE } from '../actions/localeConfigActions';

//
// Actions
//

type TLocaleConfigState = {};

export type TActions = {
  setLocaleConfig(param: any): TAction<any>;
};

export const actions: TActions = {
  setLocaleConfig(data: any) {
    return { type: SET_LOCALE_CONFIG_CODE, payload: data };
  }
};
//
// Reducer
//

// convert from friendly language code to actual language code
const REMAP_LANGUAGE_CODES: any = {
  cn: 'zh'
};

export function reducer(state: any = {}, action: TAction<any>): Partial<TLocaleConfigState> {
  switch (action.type) {
    case SET_LOCALE_CONFIG_CODE: {
      return {
        ...state,
        code: REMAP_LANGUAGE_CODES[action.payload] || action.payload
      };
    }
    default:
      return state;
  }
}

//
// saga exports
//
